import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// CSS - loaded via webpack (previously served from static/)
import './css/bootstrap.css';
import './css/bootstrap-datetimepicker.css';
import './css/toastr.css';
import './css/scrumonline.css';

// Font Awesome 6 Free
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/css/v4-shims.min.css';

console.log('[index.js] Starting React application');
const root = ReactDOM.createRoot(document.getElementById('root'));
console.log('[index.js] Created root, rendering App');
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
console.log('[index.js] App rendered');
